// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = "https://zctacexxhzjuntlnltqa.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpjdGFjZXh4aHpqdW50bG5sdHFhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU1Mjk2NzQsImV4cCI6MjA3MTEwNTY3NH0.3YKbVNIbEuB8mue8jWOOkXrdLpZbGH5FBpaH6EC01m4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});